<script>
import Layout from "../../layouts/blank";
import appConfig from "@/app.config";

import { projectService } from "../../../services/projectservice/project.service";
import { priceversionService } from "../../../services/propertyservice/priceversion.service";
import { servicehelpers } from "../../../services/servicehelpers";
// import Button from "@/components/c-button";
import Select from "@/components/c-select";
import moment from 'moment'

/* eslint-disable no-console */
export default {
  page: {
    title: "Project sumary",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
      Layout, 
      // PageHeader, 
      // Button, 
      Select },
  data() {
    return {
      title: "Project sumary",
      fullscreen: true,
      items: [
        {
          text: "project",
          href: "/",
        },
        {
          text: "Detail", 
          active: true,
        },
      ],
      data: [],
      isShowPrice: false,
      projectData: {},
      dataProject: 1,
      priceVersionData: {},
      dataPriceVersion: 0,
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);

    this.liveUpdate(this.dataProject);

    // this.loadingData(this.dataProject);
    this.loadingProjectData();
    this.loadingPriceVersionData(this.dataProject);

    
    // this.initFullScreen();
    
  },
  methods: {
    loadingData: function(id, version = 100) {
      
      this.fetchingStats = false;
      projectService.sumary(id, version)
        .then(response => {
          this.data = response.data;
          console.log(this.data);
        });
    },
    moment: function () {
      return moment();
    },

    formatCurrency(value) {
      if(value == 0 ){
        return '';
      }
      let sign = '$';
      let decimal = '';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;

    },
    numberFormat(value) {
      if(value == 0 ){
        return '';
      }
      let sign = '';
      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },
    print() {
      window.print();
    },

    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
       
    showPrice: function() {
      this.isShowPrice? this.isShowPrice = false : this.isShowPrice = true;
      console.log(this.isShowPrice)
    },

    loadingProjectData: function() {
      servicehelpers.getProjectData().then(response => {
        this.projectData = response;
      });
    },

    loadingPriceVersionData: function(projectId) {
      let param = `?clause={"clause":[{"conjuction":"and","price_versions.project_id":{"value":${projectId}}}]}`;
      priceversionService.getList(param).then(response => {
        this.priceVersionData = response;
        let obj = this.priceVersionData.data[this.priceVersionData.data.length - 1];
        this.dataPriceVersion = obj ? obj.id : 0;

      });
    },

    liveUpdate: function(projectId) {

      priceversionService.live(projectId)
         .then(response => {
           if(response.status == 200) {
              console.log("Success");

              this.loadingData(projectId);
           }
          
        });

    },

    projectChanged: function(event) {
      this.loadingPriceVersionData(event);
    },
    
    priceVersionChanged: function(event) {
      // console.log(event);
      this.loadingData(this.dataProject, event);

      let id = this.priceVersionData.data[this.priceVersionData.data.length - 1].id;

      // console.log(this.priceVersionData.data.length - 1);

      if(event == id) {
        
        this.liveUpdate(this.dataProject);
      }

    },
  },
  computed: {
    
  }
};

</script>

<template>
  <Layout>
      <div class="row search-area mb-3">
        <div class="col-sm-8">
          <div class="row">
             <div class="col-sm-4">
              <Select 
                :text="'name'"
                :id="'project_id'"
                @change="projectChanged" 
                v-model="dataProject"
                :list="this.projectData"
                :label="'property.project'"
              /> 
             </div>
             <div class="col-sm-6">
              <Select 
                :text="'name'"
                :id="'project_id'"
                @change="priceVersionChanged" 
                v-model="dataPriceVersion"
                :list="this.priceVersionData"
                :label="'property.update-price.version'"
              /> 
             </div>
             <div class="col-sm-2">
                <button
                  type="button"
                  style="margin-top: 10px;"
                  class="btn header-item noti-icon"
                  @click="initFullScreen"
                >
                  <i class="bx bx-fullscreen"></i>
                </button>
             </div>
          </div>
        </div>
      </div>
      <div>
        <table width="100%" class="content-general bottom">
          <tr>
            <td style="width: 90px;"><p>&nbsp;</p></td>
            <td><p>&nbsp;</p></td>
            <td><p>&nbsp;</p></td>
            <td style="width: 32em;"><p>&nbsp;</p></td>
          </tr>
          <tr>
            <td><img src="@/assets/images/h-logo.svg" alt width="70" /></td>
            <td>
              <p class="khb h5"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
              <p class="enb h6"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
              <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
              <p class="khs h8">ទូរស័ព្ទលេខៈ 092 926 688 | 086 626 689  Email: sales@h-residence.net</p>
            </td>
            <td>

            </td>
            <td class="right"  style="display: flex; flex-wrap: nowrap;">
                <div>
                  <p class="khm h6"><u>តារាងតម្លៃ (PRICE LIST)</u></p>
                  <p class="khb h6"><b>គម្រោងៈ លំនៅឋាន អេច សែនសុខ</b></p>
                  <p class="khb h8"><b>PROJECT: RESIDENCE H SENSOK</b></p>
                  <p class="khb h8"><b>បច្ចុប្បន្នភាព: {{this.moment().format('DD-MMM-YYYY')}}</b></p>  
                </div>
                <img src="@/assets/images/logo-dark.png" alt height="50" style="margin-bottom: 20px;" />
                <!-- <p class="khb h8"><b>បច្ចុប្បន្នភាព: {{data.current_version && data.current_version.for_date_show}}</b></p>   -->
            </td>

          </tr>
          
        </table>
        <table class="content-general h8 project-sumary-table-01 mt-1" width="100%">
          
            <!-- <tr class="thead">
              <th>TYPE</th>
              <th v-for="head in data.header" :key="head.id">UNIT "{{head.name}}"</th>
            </tr>
            <tr class="thead">
              <th><span class="en">SIZE</span></th>
              <th v-for="head in data.header" :key="head.id"><span class="en">{{numberFormat(head.size)}}M<sup>2</sup></span></th>
            </tr> -->
            <tr class="enb thead">
              <th><span class="enb h7">TYPE</span></th>
              <th v-for="head in data.header" :key="head.id"><span class="enb h7">UNIT "{{head.name}}"</span></th>
            </tr>
            <tr class="enb thead">
              <th><span class="enb h7">SIZE</span></th>
              <th v-for="head in data.header" :key="head.id"><span class="enb h7">{{numberFormat(head.size)}}M<sup>2</sup></span></th>
            </tr>

          <tbody>
            <tr v-for="(list, index) in data.body" :key="index">
              <td>
                <div style="background-color: #cccccc">
                  <span class="enb h7">
                    {{index}}
                  </span>
                </div>
              </td>
              
              <td v-for="(head, g_id) in data.header" :key="g_id" >
                  <div v-if="(typeof list[head.id] == 'undefined') == false" :title="list[head.id].status_name + '(' + list[head.id].id + ')'" :style="'width: 100%; background-color: ' + list[head.id].color_code + ';'">
                    <span class="enb h7" v-if="(list[head.id].hide_price == 1 && !isShowPrice)">
                      -
                    </span>
                    <span class="enb h7" v-else>
                      {{formatCurrency(list[head.id].price)}}
                    </span>
                </div>
              </td>
            </tr>
              <tr style="background-color: #50a5f1 !important;" v-show="this.isShowPrice">
              <td style="background-color: #50a5f1 !important;" class="text-center text-white"><span class="enb h7">TOTAL</span></td>
              <td v-for="foot in data.footer" :key="foot" class="border text-white text-center" style="background-color: #50a5f1 !important;"><span class="enb h7">{{formatCurrency(foot)}}</span></td>
            </tr>
          </tbody>
        </table>
        <table width="100%">
            <tr>
              <td width="50%">
                <div style="border: 0.5px solid #dedfe0; padding: 5px; box-shadow: 1px 5px 5px 0px #dedfe0;" class="mt-1">
                  <sapn class="khm h7"><u>បន្ថែមជូន៖</u><br></sapn>
                  <sapn class="khb h7">កញ្ចក់ខណ្ទកន្លែងងូតទឹក, ផ្កាឈូក, ឡាវ៉ាបូជាប់ជញ្ជាំង, កញ្ជក់ឆ្លុះមុខ, បង្គន់, កង្ហារបឺតក្លិន, តុចង្ក្រានបិទម៉ាប, </sapn>
                  <br>
                  <sapn class="khb h7">ចង្ក្រានអគ្គិសនី១គ្រឿង, ម៉ាស៊ីនបឺតផ្សែង១គ្រឿង, ស៊ីងលាងចាន, និងទូដាក់សម្ភារៈផ្ទះបាយ លើ/ក្រោម ទូដាក់ស្បែកជើង។</sapn>
                </div>
                <div>
                  <sapn class="khb h7">
                    <span style="font-size: 20px">&#9745;</span> អាងហែលទឹក | 
                    <span style="font-size: 20px">&#9745;</span> ស្កាយ-ផាតធី |
                    <span style="font-size: 20px">&#9745;</span> មីនីម៉ាត |
                    <span style="font-size: 20px">&#9745;</span> សេវាសន្តិសុខ ២៤-ម៉ោង | 
                    <span style="font-size: 20px">&#9745;</span> សេវាអនាម័យ
                  </sapn>
                  <br>
                  <sapn class="khb h7">
                    <span style="font-size: 20px">&#9745;</span> ចំណតរថយន្ត ៦-ជាន់ |
                    <span style="font-size: 20px">&#9745;</span> ចំណតម៉ូតូ ១-ជាន់  |
                    <span style="font-size: 20px">&#9745;</span> ក្លឹបហាត់ប្រាណ | 
                    <span style="font-size: 20px">&#9745;</span> បន្ទប់ស្ទីម សោណា (ស្រី/ប្រុស)
                  </sapn>
                  <br>
                  <br>
                  <br>
                </div>
              </td>
              <td width="10%"></td>
              <td width="40%" style="vertical-align: top;">
                <div class="total mt-1" :style="isShowPrice?'display:block':'display:none'">
                  <table width="100%" style="margin-top:2px;" class="khb price_version_sumary">
                    <tr class="th">
                      <td v-if="data.current_version && data.current_version.version == 0" colspan="2">
                        តម្លៃបើកលក់ដើមគ្រា
                      </td>
                      <td v-else colspan="2">
                        តម្លៃលក់គ្រាឡើងថ្លៃលើកទី-{{data.current_version && data.current_version.version}}
                      </td>
                    </tr>
                    <tr v-show="data.sumary && data.sumary.total_price != 0" class="pendding">
                      <td><span class="khb h7">ចំនួនយូនីតសរុប ({{data.sumary && data.sumary.unit_amount}})</span></td>
                      <td class="enb h7"> = {{formatCurrency(data.sumary && data.sumary.total_price)}}</td>
                    </tr>
                    <tr v-show="data.sumary && data.sumary.increase_price != 0" class="pendding">
                      <td><span class="khb h7">ឡើងថ្លៃលើកទី-{{data.current_version && data.current_version.version}} ({{data.current_version && data.current_version.percentage}}%)</span></td>
                      <td class="enb h7"> = {{formatCurrency(data.sumary && data.sumary.increase_price)}}</td>
                    </tr>
                    <tr class="pendding">
                      <td><span class="khb h7">សរុបតម្លៃរួម</span></td>
                      <td class="en h7"> = {{formatCurrency(data.sumary && data.sumary.all_price)}}</td>
                    </tr>
                    <tr class="sold" :style="`background-color: ${data.current_version && data.current_version.sold_color}`">
                      <td><span class="khb h7">បានលក់ ({{data.sumary && data.sumary.sold_amount}})</span></td>
                      <td class="en h7"> = {{formatCurrency(data.sumary && data.sumary.sold_price)}}</td>
                    </tr>
                    <tr v-if="data.info && data.info.version_id == data.info.last_version" class="booking">
                      <td><span class="khb h7">ចំនួនយូនីតកក់ ({{data.sumary && data.sumary.booking_amount}})</span></td>
                      <td class="en h7"> = {{formatCurrency(data.sumary && data.sumary.booking_price)}}</td>
                    </tr>
                    <tr class="pendding">
                      <td><span class="khb h7">ចំនួនយូនីតនៅសល់ ({{data.sumary && data.sumary.pending_amount}})</span></td>
                      <td class="en h7"> = {{formatCurrency(data.sumary && data.sumary.pending_price)}}</td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
        </table>
      </div>
  </Layout>
</template>